<template>
  <div class="column">
    <a-tabs default-active-key="signed" size="large">
      <a-tab-pane key="signed" tab="Signed">
        <shift-time :times="signedTime" />
      </a-tab-pane>
      <a-tab-pane key="actual" tab="Tracked">
        <shift-time :times="actualTime" />
      </a-tab-pane>
      <a-tab-pane key="scheduled" tab="Scheduled">
        <shift-time :times="scheduledTime" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { Tabs } from 'ant-design-vue'
import shiftsHelper from '@/helpers/shifts'
import validation from '@/modules/shifts/mixins/ShiftValidationMixin'
import ShiftTime from '../shift-time.vue'

export default {
  components: {
    'a-tabs': Tabs,
    'a-tab-pane': Tabs.TabPane,
    'shift-time': ShiftTime
  },
  props: {
    shift: {
      type: Object,
      default: undefined
    }
  },
  mixins: [shiftsHelper, validation],
  computed: {
    scheduledTime() {
      return this.generateTimeData('scheduled_')
    },

    actualTime() {
      return this.generateTimeData('actual_')
    },

    signedTime() {
      return this.generateTimeData('')
    }
  },
  methods: {
    generateTimeData(prefix) {
      return {
        scheduled_start: this.shift.scheduled_start,
        scheduled_end: this.shift.scheduled_end,
        start: prefix === 'scheduled_' ? this.shift[`${prefix}start`] : this.shift[`${prefix}work_start`],
        end: prefix === 'scheduled_' ? this.shift[`${prefix}end`] : this.shift[`${prefix}work_end`],
        lunch_start: this.shift[`${prefix}lunch_start`] || null,
        lunch_end: this.shift[`${prefix}lunch_end`] || null,
        lunch_duration: this.shift[`${prefix}lunch_duration`] || null,
        second_lunch_start: this.shift[`${prefix}second_lunch_start`] || null,
        second_lunch_end: this.shift[`${prefix}second_lunch_end`] || null,
        second_lunch_duration: this.shift[`${prefix}second_lunch_duration`] || null,
        work_hours: this.shift?.hours[`${prefix}work_hours`] * 60 || null,
        pay_hours: this.shift?.hours[`${prefix}pay_hours`] * 60 || null,
        duration: this.shift?.hours[`${prefix}duration`] * 60 || null
      }
    }
  }
}
</script>

<style scoped>
.column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

p {
  display: flex;
  justify-content: space-between;
}

.ant-tabs {
  border: 1px solid var(--border-color-base);
  border-radius: 10px;
}

::v-deep .ant-tabs-bar {
  margin: 0;
}

::v-deep .ant-descriptions {
  border: 0;
  border-radius: 0;
}
</style>
